import { render, staticRenderFns } from "./orderCommentList.vue?vue&type=template&id=49d07db2&scoped=true&"
import script from "./orderCommentList.vue?vue&type=script&lang=js&"
export * from "./orderCommentList.vue?vue&type=script&lang=js&"
import style0 from "./orderCommentList.vue?vue&type=style&index=0&id=49d07db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d07db2",
  null
  
)

export default component.exports